import React from "react";
import {
  Box,
  Carousel,
  Image,
  Heading,
  ResponsiveContext,
} from "grommet";

// const data = [
//   "../../1.png",
//   "../../2.png",
//   "../../3.png",
//   "../../4.png",
//   "../../5.png",
//   "../../6.png",
//   "../../7.png",
//   "../../8.png",
//   "../../9.png",
// ];

const Clients = [
  "../../7a.png",
  "../../6a.png",
  "../../1a.png",
  "../../8a.png",
];

export const Partner = () => (
  <ResponsiveContext.Consumer>
    {(size) =>
      size === "small" ? (
        <Box
          width="full"
          direction="column"
          align="center"
          pad={{ vertical: "small" }}
        >
          <Heading
            level={2}
            size="small"
            color="border"
            textAlign="center"
            alignSelf="start"
            margin={{ left: "medium" }}
          >
            Our Clients
          </Heading>
          <Box
            direction="row"
            gap="xsmall"
            pad={{ horizontal: "small" }}
            wrap
            justify="between"
          >
            {Clients.map((img) => (
              <Image
                key={img}
                src={img}
                style={{
                  width: "110px",
                  height: "100px",
                  overflow: "visible",
                }}
                fit="contain"
                opacity="0.5"
              />
            ))}
          </Box>
        </Box>
      ) : (
        <Box
          width="full"
          direction="column"
          align="center"
          pad={{ vertical: "medium" }}
        >
          <Heading
            level={2}
            margin="none"
            size="small"
            color="border"
            textAlign="center"
          >
            Our Clients
          </Heading>
          <Box
            direction="row"
            gap="medium"
            justify="between"
            pad={{ horizontal: "small" }}
          >
            {Clients.map((img) => (
              <Image
                key={img}
                src={img}
                fit="contain"
                style={{
                  width: "150px",
                  height: "120px",
                  overflow: "visible",
                }}
                opacity="0.5"
              />
            ))}
          </Box>
        </Box>
      )
    }
  </ResponsiveContext.Consumer>
);
